import { getConfig } from '../../../utils/LoadingData';

export default getConfig({ transform: (data: any) => true });
